if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        this.currentIndex = 0;
        this.lightboxReady = false;

        this.handleKeydown = (event) => {
          if (!this.openedBy) return;

          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.changeImage(-1);
          }

          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.changeImage(1);
          }
        };

        this.handleArrowClick = (event) => {
          const button = event.target.closest(
            '[data-product-modal-prev], [data-product-modal-next]'
          );

          if (!button || !this.contains(button)) return;

          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();

          if (button.hasAttribute('data-product-modal-prev')) {
            this.changeImage(-1);
          } else {
            this.changeImage(1);
          }
        };
      }

      show(opener) {
        super.show(opener);

        this.createLightbox();
        this.showSelectedImage();

        document.removeEventListener(
          'keydown',
          this.handleKeydown
        );

        document.addEventListener(
          'keydown',
          this.handleKeydown
        );
      }

      hide() {
        document.removeEventListener(
          'keydown',
          this.handleKeydown
        );

        super.hide();
      }

      createLightbox() {
        const dialog = this.querySelector(
          '.product-media-modal__dialog'
        );

        const content = this.querySelector(
          '[role="document"]'
        );

        if (!dialog || !content) return;

        this.classList.add('custom-product-lightbox');
        dialog.classList.add(
          'custom-product-lightbox-dialog'
        );
        content.classList.add(
          'custom-product-lightbox-content'
        );

        if (!this.lightboxReady) {
          this.addEventListener(
            'click',
            this.handleArrowClick,
            true
          );

          this.lightboxReady = true;
        }

        if (!this.querySelector(
          '[data-product-modal-prev]'
        )) {
          const previousButton =
            document.createElement('button');

          previousButton.type = 'button';
          previousButton.setAttribute(
            'aria-label',
            'Previous image'
          );
          previousButton.setAttribute(
            'data-product-modal-prev',
            ''
          );
          previousButton.className =
            'custom-product-lightbox-arrow custom-product-lightbox-arrow--previous';
          previousButton.innerHTML = '&#10094;';

          dialog.appendChild(previousButton);
        }

        if (!this.querySelector(
          '[data-product-modal-next]'
        )) {
          const nextButton =
            document.createElement('button');

          nextButton.type = 'button';
          nextButton.setAttribute(
            'aria-label',
            'Next image'
          );
          nextButton.setAttribute(
            'data-product-modal-next',
            ''
          );
          nextButton.className =
            'custom-product-lightbox-arrow custom-product-lightbox-arrow--next';
          nextButton.innerHTML = '&#10095;';

          dialog.appendChild(nextButton);
        }

        if (
          !document.querySelector(
            '#custom-product-lightbox-styles'
          )
        ) {
          const style = document.createElement('style');

          style.id =
            'custom-product-lightbox-styles';

          style.textContent = `
            .custom-product-lightbox {
              position: fixed !important;
              inset: 0 !important;
              z-index: 9999 !important;
              display: flex !important;
              align-items: center !important;
              justify-content: center !important;
              background: rgba(0, 0, 0, 0.86) !important;
            }

            .custom-product-lightbox-dialog {
              position: relative !important;
              display: block !important;
              width: min(600px, 86vw) !important;
              max-width: min(600px, 86vw) !important;
              height: auto !important;
              max-height: 86vh !important;
              margin: auto !important;
              padding: 0 !important;
              overflow: hidden !important;
              background: #000000 !important;
              border: 0 !important;
              box-shadow: none !important;
            }

            .custom-product-lightbox-content {
              position: relative !important;
              display: block !important;
              width: 100% !important;
              max-width: 100% !important;
              height: auto !important;
              max-height: 86vh !important;
              margin: 0 !important;
              padding: 0 !important;
              overflow: hidden !important;
              background: #000000 !important;
            }

            .custom-product-lightbox-content
            [data-media-id] {
              display: none !important;
              position: relative !important;
              width: 100% !important;
              max-width: 100% !important;
              height: auto !important;
              max-height: 86vh !important;
              margin: 0 !important;
              padding: 0 !important;
              overflow: hidden !important;
              align-items: center !important;
              justify-content: center !important;
              background: #000000 !important;
            }

            .custom-product-lightbox-content
            [data-media-id].active {
              display: flex !important;
              width: 100% !important;
              max-width: 100% !important;
            }

            .custom-product-lightbox-content
            [data-media-id].active > * {
              display: block !important;
              width: 100% !important;
              max-width: 100% !important;
              height: auto !important;
              max-height: 86vh !important;
              flex: 1 1 auto !important;
              background: #000000 !important;
            }

            .custom-product-lightbox-content
            [data-media-id].active img,
            .custom-product-lightbox-content
            [data-media-id].active video,
            .custom-product-lightbox-content
            [data-media-id].active iframe {
              display: block !important;
              width: 100% !important;
              max-width: 100% !important;
              height: auto !important;
              max-height: 86vh !important;
              margin: 0 auto !important;
              object-fit: contain !important;
            }

            .custom-product-lightbox-arrow {
              position: absolute !important;
              top: 50% !important;
              z-index: 100 !important;
              display: flex !important;
              align-items: center !important;
              justify-content: center !important;
              width: 48px !important;
              height: 48px !important;
              margin: 0 !important;
              padding: 0 !important;
              border: 0 !important;
              border-radius: 50% !important;
              background: rgba(0, 0, 0, 0.72) !important;
              color: #ffffff !important;
              font-size: 34px !important;
              line-height: 1 !important;
              cursor: pointer !important;
              opacity: 1 !important;
              visibility: visible !important;
              transform: translateY(-50%) !important;
              appearance: none !important;
            }

            .custom-product-lightbox-arrow:hover {
              background: #000000 !important;
            }

            .custom-product-lightbox-arrow:disabled {
              display: flex !important;
              opacity: 1 !important;
              pointer-events: auto !important;
            }

            .custom-product-lightbox-arrow--previous {
              left: 14px !important;
            }

            .custom-product-lightbox-arrow--next {
              right: 14px !important;
            }

            .custom-product-lightbox
            .product-media-modal__toggle {
              position: absolute !important;
              top: 12px !important;
              right: 12px !important;
              z-index: 110 !important;
              width: 42px !important;
              height: 42px !important;
              color: #ffffff !important;
              background: rgba(0, 0, 0, 0.65) !important;
            }

            @media screen and (max-width: 749px) {
              .custom-product-lightbox-dialog {
                width: 90vw !important;
                max-width: 90vw !important;
              }

              .custom-product-lightbox-arrow {
                width: 40px !important;
                height: 40px !important;
                font-size: 28px !important;
              }
            }
          `;

          document.head.appendChild(style);
        }
      }

      getImages() {
        const content = this.querySelector(
          '[role="document"]'
        );

        if (!content) return [];

        return Array.from(
          content.querySelectorAll('[data-media-id]')
        );
      }

      showSelectedImage() {
        const images = this.getImages();

        if (!images.length) return;

        const mediaId = this.openedBy
          ? this.openedBy.getAttribute('data-media-id')
          : null;

        let selectedImage = images[0];

        if (mediaId) {
          const matchingImage = images.find(
            (image) =>
              image.getAttribute('data-media-id') === mediaId
          );

          if (matchingImage) {
            selectedImage = matchingImage;
          }
        }

        this.currentIndex = Math.max(
          0,
          images.indexOf(selectedImage)
        );

        this.displayImage(selectedImage);
      }

      displayImage(image) {
        const images = this.getImages();

        if (!image || !images.length) return;

        images.forEach((item) => {
          const isActive = item === image;

          item.classList.toggle('active', isActive);
          item.setAttribute(
            'aria-hidden',
            isActive ? 'false' : 'true'
          );
        });

        const imageTemplate =
          image.querySelector('template');

        const imageTemplateContent = imageTemplate
          ? imageTemplate.content
          : null;

        if (
          image.nodeName === 'DEFERRED-MEDIA' &&
          imageTemplateContent &&
          imageTemplateContent.querySelector('.js-youtube')
        ) {
          image.loadContent();
        }

        image.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center',
        });
      }

      changeImage(direction) {
        const images = this.getImages();

        if (images.length < 2) return;

        const activeIndex = images.findIndex((image) =>
          image.classList.contains('active')
        );

        const startingIndex =
          activeIndex >= 0
            ? activeIndex
            : this.currentIndex;

        this.currentIndex =
          (startingIndex + direction + images.length) %
          images.length;

        this.displayImage(
          images[this.currentIndex]
        );
      }
    }
  );
}
